<template>
  <div class="manufacturer-history">
    <!-- Ce qui s'est passé : renommages, alias, fusions, gammes, réglages -->
    <v-card outlined>
      <div v-if="history === null" class="text-center my-6"><v-progress-circular indeterminate color="primary" /></div>
      <v-simple-table v-else dense>
        <tbody>
          <tr v-if="!history.length"><td class="text--secondary">{{ $t('manufacturer.sheet.history-none') }}</td></tr>
          <tr v-for="entry in history" :key="entry.id">
            <td class="text-caption text-no-wrap" style="width: 1%">{{ formatDate(entry.occurredAt, 'DD/MM/YYYY HH:mm') }}</td>
            <td>
              <div>{{ historyLabel(entry) }}<span v-if="entry.targetName" class="text--secondary"> · {{ entry.targetName }}</span></div>
              <div class="text-caption text--secondary">{{ historyDetail(entry) }}</div>
            </td>
            <td class="text-caption text-right">{{ entry.actorName || '-' }}</td>
          </tr>
        </tbody>
      </v-simple-table>
    </v-card>
  </div>
</template>

<script>
import ManufacturerRepository from "@repository/ManufacturerRepository";

/** L'historique d'un constructeur : ses renommages, ses alias, ses fusions, ses gammes et ses réglages, et par qui. */
export default {
  data() {
    return {
      history: null,
    }
  },

  mounted() {
    ManufacturerRepository.history(this.$route.params.id).then(history => {
      this.history = history
    }).catch(err => {
      this.notifyError(err)
    })
  },

  methods: {
    historyLabel(entry) {
      // Les points des noms d'action (« manufacturer.merged ») couperaient la clé de traduction.
      const key = 'manufacturer.sheet.history-actions.' + entry.action.replace(/\./g, '--')
      return this.$te(key) ? this.$t(key) : entry.action
    },

    // Ce qui a changé, en une ligne (avant → après), sans les identifiants techniques.
    historyDetail(entry) {
      const fields = [...new Set([...Object.keys(entry.before || {}), ...Object.keys(entry.after || {})])].filter(field => !/id$/i.test(field))
      return fields.map(field => {
        const show = value => Array.isArray(value) ? value.join(', ') : (value === null || value === undefined ? '∅' : String(value))
        const before = entry.before && field in entry.before ? show(entry.before[field]) : null
        const after = entry.after && field in entry.after ? show(entry.after[field]) : null
        return `${field} : ${before !== null && after !== null ? before + ' → ' + after : (after ?? before)}`
      }).join(' · ')
    },
  },
}
</script>
